.mainForm-overlay{padding:1%}.mainForm-overlay h2,.mainForm-overlay form,.mainForm-overlay form .mat-form-field{width:100%}.mainForm-overlay form .button-wrapper{margin-bottom:3%}
/*# sourceMappingURL=create-form-dialog.component-VKBQEYOS.css.map */
